import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import AppSidebar from "@/components/AppSidebar";
import AppHeader from "@/components/AppHeader";
import { useAuth } from "@/components/AuthProvider";
import { CurrentShopProvider } from "@/components/CurrentShopProvider";

const DESKTOP_BREAKPOINT = 1024; // lg breakpoint

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= DESKTOP_BREAKPOINT);
  const { isSample } = useAuth();

  return (
    <CurrentShopProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="flex-1 flex flex-col min-w-0">
          <AppHeader onMenuToggle={() => setSidebarOpen(true)} />
          {isSample && (
            <div className="flex items-center gap-2 px-4 py-2 bg-amber-50 border-b border-amber-200 text-amber-800 text-sm">
              <AlertTriangle className="h-4 w-4 flex-shrink-0" />
              <span>サンプルモードで閲覧中です。データの変更はできません。</span>
            </div>
          )}
          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </CurrentShopProvider>
  );
};

export default DashboardLayout;
